import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles, categories } from '@/mocks/articles';

const articleHeroImages: Record<string, string> = {
  "dingji-wanghong-renshe-bengta": "https://readdy.ai/api/search-image?query=Dark%20moody%20influencer%20scandal%20smartphone%20leaked%20messages%20warm%20amber%20lighting%20shallow%20depth%20cinematic%20noir%20high%20contrast%20editorial&width=1920&height=800&seq=article-hero-wanghong-01&orientation=landscape",
  "dingji-mingxing-shuiwu-weigui": "https://readdy.ai/api/search-image?query=Dark%20celebrity%20tax%20investigation%20blurred%20luxury%20items%20documents%20moody%20lighting%20cinematic%20noir%20high%20contrast%20editorial&width=1920&height=800&seq=article-hero-mingxing-01&orientation=landscape",
  "zhibo-daihuo-jiahuo-neimu": "https://readdy.ai/api/search-image?query=Dark%20live%20streaming%20scandal%20packages%20scattered%20moody%20lighting%20cinematic%20investigative%20journalism%20high%20contrast&width=1920&height=800&seq=article-hero-redian-01&orientation=landscape",
  "nv-tuan-chengyuan-bei-ba-ling": "https://readdy.ai/api/search-image?query=Dark%20K-pop%20girl%20group%20dramatic%20shadows%20silhouettes%20backstage%20tension%20cinematic%20lighting%20artistic%20high%20contrast&width=1920&height=800&seq=article-hero-bagua-01&orientation=landscape",
  "dahu-shangye-jiaoyi-beihou": "https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20documents%20money%20sophisticated%20investigation%20moody%20lighting%20cinematic%20high%20contrast&width=1920&height=800&seq=article-hero-shenba-01&orientation=landscape",
  "shipin-paishedao-luren-gongkai": "https://readdy.ai/api/search-image?query=Dark%20nighttime%20street%20luxury%20hotel%20silhouettes%20dramatic%20lights%20paparazzi%20cinematic%20noir%20high%20contrast&width=1920&height=800&seq=article-hero-shipin-01&orientation=landscape",
  "wanghong-daihuo-jia-mao-zhengshu": "https://readdy.ai/api/search-image?query=Dark%20desk%20fake%20certificate%20magnifying%20glass%20forgery%20moody%20atmosphere%20warm%20amber%20cinematic%20editorial%20high%20detail&width=1920&height=800&seq=article-hero-wanghong-02&orientation=landscape",
  "liangyi-jie-baoguang-yiliao-shigu": "https://readdy.ai/api/search-image?query=Dark%20medical%20surgical%20tools%20shadow%20moody%20atmosphere%20cinematic%20lighting%20high%20contrast%20warm%20accent&width=1920&height=800&seq=article-hero-redian-02&orientation=landscape",
  "xianggang-dingji-yiren-bei-ju-bao": "https://readdy.ai/api/search-image?query=Dark%20Hong%20Kong%20night%20financial%20district%20luxury%20mystery%20cinematic%20reflections%20shadows%20high%20contrast%20urban%20noir&width=1920&height=800&seq=article-hero-mingxing-02&orientation=landscape",
  "duanshipin-pingtai-neirong-zhengce": "https://readdy.ai/api/search-image?query=Dark%20content%20moderation%20screens%20social%20media%20feeds%20shadow%20moody%20tech%20surveillance%20cinematic%20high%20contrast&width=1920&height=800&seq=article-hero-shenba-02&orientation=landscape",
  "wangluo-zhubo-bei-qi-pian-ji-qian-wan": "https://readdy.ai/api/search-image?query=Dark%20gaming%20room%20empty%20chair%20scattered%20money%20moody%20deception%20cinematic%20warm%20accent%20high%20detail&width=1920&height=800&seq=article-hero-bagua-02&orientation=landscape",
  "jianju-huizhan-baoliao-chigua-quanjilu": "https://readdy.ai/api/search-image?query=Dark%20year%20in%20review%20calendar%20pages%20dramatic%20lighting%20moody%20highlights%20cinematic%20warm%20golden%20hour&width=1920&height=800&seq=article-hero-redian-03&orientation=landscape",
};

const relatedArticleImages: Record<string, string> = {
  "dingji-wanghong-renshe-bengta": "https://readdy.ai/api/search-image?query=Dark%20moody%20influencer%20scandal%20smartphone%20leaked%20messages%20warm%20amber%20lighting%20cinematic%20noir&width=600&height=400&seq=related-wanghong-01&orientation=landscape",
  "wanghong-daihuo-jia-mao-zhengshu": "https://readdy.ai/api/search-image?query=Dark%20desk%20fake%20certificate%20magnifying%20glass%20forgery%20moody%20warm%20amber%20cinematic%20editorial&width=600&height=400&seq=related-wanghong-02&orientation=landscape",
  "dingji-mingxing-shuiwu-weigui": "https://readdy.ai/api/search-image?query=Dark%20celebrity%20tax%20investigation%20luxury%20items%20documents%20moody%20cinematic%20noir%20high%20contrast&width=600&height=400&seq=related-mingxing-01&orientation=landscape",
  "xianggang-dingji-yiren-bei-ju-bao": "https://readdy.ai/api/search-image?query=Dark%20Hong%20Kong%20night%20financial%20district%20luxury%20mystery%20cinematic%20shadows%20high%20contrast&width=600&height=400&seq=related-mingxing-02&orientation=landscape",
  "zhibo-daihuo-jiahuo-neimu": "https://readdy.ai/api/search-image?query=Dark%20live%20streaming%20scandal%20packages%20scattered%20moody%20cinematic%20investigative%20journalism&width=600&height=400&seq=related-redian-01&orientation=landscape",
  "liangyi-jie-baoguang-yiliao-shigu": "https://readdy.ai/api/search-image?query=Dark%20medical%20surgical%20tools%20shadow%20moody%20cinematic%20lighting%20high%20contrast%20warm%20accent&width=600&height=400&seq=related-redian-02&orientation=landscape",
  "jianju-huizhan-baoliao-chigua-quanjilu": "https://readdy.ai/api/search-image?query=Dark%20year%20review%20calendar%20pages%20dramatic%20lighting%20moody%20highlight%20cinematic%20warm%20golden&width=600&height=400&seq=related-redian-03&orientation=landscape",
  "nv-tuan-chengyuan-bei-ba-ling": "https://readdy.ai/api/search-image?query=Dark%20K-pop%20girl%20group%20dramatic%20shadows%20silhouettes%20backstage%20cinematic%20lighting%20high%20contrast&width=600&height=400&seq=related-bagua-01&orientation=landscape",
  "wangluo-zhubo-bei-qi-pian-ji-qian-wan": "https://readdy.ai/api/search-image?query=Dark%20gaming%20room%20empty%20chair%20scattered%20money%20moody%20deception%20cinematic%20warm%20accent&width=600&height=400&seq=related-bagua-02&orientation=landscape",
  "shipin-paishedao-luren-gongkai": "https://readdy.ai/api/search-image?query=Dark%20nighttime%20street%20luxury%20hotel%20silhouettes%20dramatic%20lights%20paparazzi%20cinematic%20noir&width=600&height=400&seq=related-shipin-01&orientation=landscape",
  "dahu-shangye-jiaoyi-beihou": "https://readdy.ai/api/search-image?query=Dark%20corporate%20boardroom%20documents%20money%20sophisticated%20investigation%20moody%20cinematic&width=600&height=400&seq=related-shenba-01&orientation=landscape",
  "duanshipin-pingtai-neirong-zhengce": "https://readdy.ai/api/search-image?query=Dark%20content%20moderation%20screens%20social%20media%20feeds%20shadow%20moody%20tech%20cinematic&width=600&height=400&seq=related-shenba-02&orientation=landscape",
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);
  const category = article ? categories.find((c) => c.id === article.category) : null;

  if (!article || !category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-900 mb-2">文章未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.category === article.category && a.id !== article.id)
    .slice(0, 3);

  const heroImage = articleHeroImages[article.slug] || articleHeroImages["dingji-wanghong-renshe-bengta"];

  const articleJsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.summary,
    "author": {
      "@type": "Person",
      "name": article.author,
    },
    "datePublished": article.publishedAt,
    "publisher": {
      "@type": "Organization",
      "name": "51吃瓜爆料网",
    },
    "url": `https://www.chigua51.com/article/${article.slug}`,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }} />
      <Navbar />
      <main>
        <article>
          <section className="relative h-80 md:h-[420px] overflow-hidden">
            <img
              src={heroImage}
              alt={article.title}
              className="w-full h-full object-cover object-top"
              title={article.title}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="w-full px-4 md:px-10 lg:px-20 pb-8">
                <div className="max-w-4xl">
                  <div className="mb-3">
                    <Breadcrumb
                      items={[
                        { label: "首页", href: "/" },
                        { label: category.name, href: `/category/${category.slug}` },
                        { label: article.title },
                      ]}
                    />
                  </div>
                  <h1 className="text-2xl md:text-4xl lg:text-5xl font-black font-heading text-background-50 leading-tight mb-3">
                    {article.title}
                  </h1>
                  <div className="flex flex-wrap items-center gap-3 text-background-50/70 text-xs md:text-sm">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-line"></i> {article.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i> {article.publishedAt}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万阅读` : `${article.views}阅读`}
                    </span>
                    <Link
                      to={`/category/${category.slug}`}
                      className="px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium cursor-pointer hover:bg-primary-600 transition-colors"
                    >
                      {category.name}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 bg-background-50">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <div className="flex flex-col md:flex-row gap-10">
                <div className="flex-1">
                  <div
                    className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed
                      [&>h2]:text-xl [&>h2]:md:text-2xl [&>h2]:font-bold [&>h2]:font-heading [&>h2]:text-foreground-900 [&>h2]:mt-8 [&>h2]:mb-4
                      [&>p]:mb-4 [&>p]:leading-relaxed [&>p]:text-sm [&>p]:md:text-base
                      [&>strong]:text-primary-600"
                    dangerouslySetInnerHTML={{ __html: article.content }}
                  />

                  <div className="mt-10 pt-6 border-t border-background-200">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="text-xs text-foreground-400">标签：</span>
                      {article.tags.map((tag) => (
                        <span
                          key={tag}
                          className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs cursor-pointer hover:bg-primary-100 hover:text-primary-600 transition-colors"
                        >
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="w-full md:w-72 flex-shrink-0">
                  <div className="md:sticky md:top-20">
                    <div className="rounded-xl bg-background-100 p-5 mb-5">
                      <h4 className="text-sm font-bold font-heading text-foreground-900 mb-3">爆料人信息</h4>
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                          <i className="ri-user-line text-primary-500"></i>
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-foreground-800">{article.author}</p>
                          <p className="text-xs text-foreground-400">51吃瓜爆料网</p>
                        </div>
                      </div>
                    </div>

                    <div className="rounded-xl bg-background-100 p-5 mb-5">
                      <h4 className="text-sm font-bold font-heading text-foreground-900 mb-3">爆料可信度</h4>
                      <div className="flex items-center gap-1.5 mb-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <i key={star} className={`ri-star-fill text-lg ${star <= 4 ? 'text-accent-500' : 'text-foreground-200'}`}></i>
                        ))}
                      </div>
                      <p className="text-xs text-foreground-400">经多渠道交叉验证，可信度高</p>
                    </div>

                    <Link
                      to={`/category/${category.slug}`}
                      className="block rounded-xl bg-primary-500 p-5 text-center cursor-pointer hover:bg-primary-600 transition-colors"
                    >
                      <span className="text-sm font-semibold text-background-50">
                        浏览更多{category.name}爆料 <i className="ri-arrow-right-line ml-1"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {relatedArticles.length > 0 && (
            <section className="py-10 md:py-14 bg-background-100">
              <div className="max-w-7xl mx-auto px-4 md:px-6">
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-8">
                  更多<span className="text-accent-600">大瓜</span>
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                  {relatedArticles.map((ra) => {
                    const raCat = categories.find((c) => c.id === ra.category);
                    const raImage = relatedArticleImages[ra.slug] || relatedArticleImages["dingji-wanghong-renshe-bengta"];
                    return (
                      <Link
                        key={ra.id}
                        to={`/article/${ra.slug}`}
                        className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
                      >
                        <div className="relative h-44 md:h-48 overflow-hidden">
                          <img
                            src={raImage}
                            alt={ra.title}
                            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                            title={ra.title}
                          />
                        </div>
                        <div className="p-4 flex flex-col flex-1">
                          <div className="flex items-center gap-2 mb-1.5">
                            {raCat && <span className="tag-accent text-[10px]">{raCat.name}</span>}
                            <span className="text-foreground-400 text-xs">{ra.publishedAt}</span>
                          </div>
                          <h3 className="text-sm font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                            {ra.title}
                          </h3>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </section>
          )}
        </article>
      </main>
      <Footer />
    </>
  );
}